var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"ConsoleNodeLoad"}},[_c('ve-histogram',{ref:"consoleNodeLoad",attrs:{"data":_vm.chartData,"extend":_vm.extend,"settings":_vm.chartSettings,"width":"100%","height":"100%","legend-visible":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5368143a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/console/ConsoleNodeLoad.vue
// module id = null
// module chunks = 